"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DisplayAnimation_1 = __importDefault(require("@web/common/DisplayAnimation"));
(() => {
    const showMoreContainers = Array.from(document.querySelectorAll('.show-more-container'));
    showMoreContainers.forEach((showMoreContainer) => {
        const showMore = showMoreContainer.querySelector('.show-more');
        const hiddenContent = showMoreContainer.querySelector('.hidden-content');
        if (showMore && hiddenContent) {
            showMore.addEventListener('click', () => {
                DisplayAnimation_1.default.slideToggle(hiddenContent);
                showMore.classList.toggle('active');
                Array.from(showMore.querySelectorAll('span')).forEach((item) => {
                    item.classList.toggle('hidden');
                });
            });
        }
    });
})();
